import { useEffect, useState } from 'react';
import { getMySubscription } from '../../api/auth.api';

// Estado de la suscripción del owner autenticado. { active, plan, expiresAt }.
export function useSubscription(uid) {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setSubscription(null);
      setLoading(false);
      return;
    }

    let active = true;
    setLoading(true);

    getMySubscription()
      .then((data) => { if (active) setSubscription(data); })
      .catch(() => { if (active) setSubscription({ active: false }); })
      .finally(() => { if (active) setLoading(false); });

    return () => { active = false; };
  }, [uid]);

  return { subscription, active: subscription?.active ?? false, loading };
}
